/*
defines appearance of the main application
*/

import LinkView from './link';
import NodeView from './node';
import ImageNodeView from './imageNode';
import WikiNodeView from './wikiNode';
import ConnectorNodeView from './connectorNode';
import KeyboardInputController from '../controller/input'
import api from 'utilities/api';
import {
    removeItem,
    getItemById,
    parseTransform,
    saveDoc,
    importDoc,
    randomizeSources,
} from '../utilities/utilities';


/**
 * defines general appearance of the application, and initializes visual components
 */
export default class GraphView {
    /**
     * makes a new graph view given a graph model
     * @param {Graph} graph
     */
    constructor(graph) {
        this.graph = graph;
        this.nodes = [];
        this.links = [];
        this.newmenu = [{
          key: 'adddevice',
          name: 'Add another...'
        }, {
          key: 'cast1',
          name: 'Cast to Daydreams Viewer 1'
        }, {
          key: 'cast2',
          name: 'Cast to Daydreams Viewer 2'
        },{
          key: 'cast3',
          name: 'Cast to Daydreams Viewer 3'
        }];

        this.width = document.body.clientWidth;
        this.height = document.body.clientHeight;

        this._enablePhysics = false;
        this.initComponents();

    }

    /**
     * initializes all of the pre-existing components in the view
     */
    initComponents() {
        this.body = d3.select('body');
        this.div = d3.select('#mynetwork').classed('start', true);

        // clear previous contents
        this.div.selectAll('*').remove();

        this.svg = this.div.append('svg');

        this.svg.attr('width', this.width)
            .attr('height', this.height)
            .attr('id', 'graph');

        this.bg = this.svg.append('rect');

        this.bg.attr('width', this.width)
                .attr('height', this.height)
                .attr('x', 0)
                .attr('y', 0)
                .attr('id', 'bg')
                .style('opacity', 0);

        this.container = this.svg.append('g');
        this.container.attr('class', 'everything');

        // this.initInstructions();
        // setTimeout(this.initIntro(),5000);

        this.initLogos();

        this.initTooltip();
        this.initInputBox();
        // this.initInfoBar(); /* don't need the instructions at bottom anymore */
        this.initStatus();
        this.initClipPreview();
        this.initGraph();

        // const availableFunctions = ['add', 'delete', 'link', 'interpolate', 'crop', 'focus', 'physics', 'reorganize', 'save', 'clear'];
        const availableFunctions = ['filter', 'add', 'delete', 'link', 'interpolate', 'launch', 'save', 'clear'];
        this.initFunctionButtons(availableFunctions);
        this.initAdd();
        this.initFilter();
        this.initCast();

        this.initLightbox();

    }

    /**
     * initializes the sideways and media lab logo on the network
     * clickable, and leads to about.html
     */
    initLogos(){
        this.sidewaysLogo = d3.select("body")
            .append('div')
            .attr('id', 'sideways-logo')
            .append('a')
            .attr('href', 'about.html')
            .append('xhtml:img')
            .attr('id', 'sidewaysimg')
            .attr('src', '/imgs/sidewayslogo.png')
            .attr('width', '50%')
            .attr('height', '50%')

        this.mediaLogo = d3.select("body")
            .append('div')
            .attr('id', 'media-logo')
            .append('a')
            .attr('href', 'about.html')
            .append('xhtml:img')
            .attr('id', 'mediaimg')
            .attr('src', '/imgs/medialogo.png')
            .attr('width', '53.5px')
            .attr('height', '25px')
    }

    /**
     * initializes a loading page instructions
     * fades away after 6 seconds in total
     *
     */
     initInstructions() {
        this.loadingbox = this.div.append('div').attr('id', 'loading-box');
        this.instructions1 = this.loadingbox.append('div')
                                    .attr('id', 'instructions1');
        this.instructions2 = this.loadingbox.append('div')
                                    .attr('id', 'instructions2');

        d3.select('#loading-box')
            .style('opacity', 1)
            .transition().delay(3500).duration(500)
            .style('opacity', 0)

        if (this.nodes.length > 0 || this.links.length > 0){
            d3.select('#loading-box').remove();
        }
     }

     /**
      * initializes a loading page instructions
      * fades away after 6 seconds in total
      *
      */
      initIntro() {

         let introbox = this.div.append('div').attr('id', 'intro-box');
         console.log(this);
         this.intro1 = introbox.append('div').attr('id', 'intro1');

         // this.intro2 = introbox.append('div').attr('class','link-box on new-on').attr('id','intro_input')
         //                      .append('span').attr('class','box__question')
         //                      .append('input').attr('class','box__input')
         //                      .attr('placeholder','keyword');
         //
         // let input = document.getElementById('intro_input')
         // input.style.width = '200px';
         // input.style.height = '100px';
         // input.style.x = '262';
         // input.style.y = '269.5';

         d3.select('#intro-box')
             .style('opacity', 0)
             .transition().delay(4000)
             .style('opacity', 1);


        let loadingbox = document.getElementById('loading-box');
        if (loadingbox.style.opacity == 0){
          console.log("getting to this point");
          loadingbox.style.display = 'none';
        }
      }

    /**
     * initializes a rectangle which previews the cropping function
     */
    initClipPreview() {
        this.clipPreview = this.container.append('rect')
            .classed('clip-preview', true)
            .attr('x', -50)
            .attr('y', -50)
            .attr('fill', 'white');
    }

    /**
     * initializes a status message bar
     */
    initStatus() {
        this.status = this.div.append('div').attr('id', 'status');
    }

    /**
     * given a list of names, initializes that many function buttons
     * @param {Array<String>} names
     */
    initFunctionButtons(names) {
        this.functions = this.div.append('div').classed('functions', true)

        // init media lab logo next to function buttons
        // this.functions
        //         .append('a')
        //         .attr('href', 'about.html')
        //         .append('xhtml:img')
        //         .attr('id', 'media-logo')
        //         .attr('src', '/imgs/medialogo.png')
        //         .attr('width', '53.5px')
        //         .attr('height', '25px')

        for (let i = 0; i < names.length; i++) {
            this.initFunctionButton(names[i]);
        }
    }

    /**
     * initializes a function button with the given name
     * makes available two public variables,
     * @example
     * // makes view.cancelButton and view.cancelWrapper
     * initFunctionButton('cancel')
     * @param {String} name
     */
    initFunctionButton(name) {
        name==="interpolate" ? console.log(name) : null;
        this[`${name}Wrapper`] = this.functions.append('div').attr('id', name).classed('function', true)
        // this[`${name}Button`] = this[`${name}Wrapper`].append('button')
        //                                 .attr('class', `${name}-button`).text(name)
        this[`${name}Button`] = this[`${name}Wrapper`].append('button')
                                                .attr('class', `${name}-button`)
                                                //.text(name)
                                                .append('xhtml:img')
                                                .attr('class', `${name}-icon`)
                                                .attr('src', `/imgs/${name}-icon.png`)
                                                .attr('width', '50px')
                                                .attr('height', '52px')

        this[`${name}Box`] = this[`${name}Wrapper`].append('div')
                                                .attr('class', `${name}-instructionbox`)
                                                //display none
    }

    /**
     * initializes buttons for adding nodes
     */
    initAdd() {
        let types = _.concat(api.available, 'connector');

        this.adders = this.addWrapper.append('div').attr('class', 'adders')
        this.nodeAdder = this.adders.selectAll('.add-node')
                        .data(types)
                        .enter()
                        .append('div')
                        .attr('class', (d) => `add-node add-node--${d}`)
                        .text((d) => api[d] ? api[d].name : d);
    }

    /**
     * initializes buttons for filter nodes
     */
    initFilter() {
        let types = api.available;

        this.filters = this.filterWrapper.append('div').attr('class', 'filters')
        this.nodeFilters = this.filters.selectAll('.filter-node')
                        .data(types)
                        .enter()
                        .append('div')
                        .attr('class', (d) => `filter-node filter-node--${d}`)
                        .text((d) => api[d] ? api[d].name : d)
                        .append('div')
                        .attr('class', (d) => `filter-toggle filter-button--${d}`)

        this.randomizeFilter = this.filters.append('div')
                            .attr('class', `filter-node filter-button filter-randomize`)
                            .text('randomize')

        this.initFilterButtons();
    }

    /**
     * initializes first selection of apis with random sources
     */
    initFilterButtons(){
        let initialApis = randomizeSources(api.available);
        initialApis.forEach(apiName => {
            this.filters.select(`.filter-button--${apiName}`)
                        .classed('on', true)
        })
    }

    /**
     * Initializes the cast menu
     */
    initCast() {
      /*
      let menu = [{
        key: 'adddevice',
        name: 'Add device...'
      }, {
        key: 'cast1',
        name: 'Device 1'
      }, {
        key: 'cast2',
        name: 'Device 2'
      },{
        key: 'cast3',
        name: 'Device 3'
      }];
      */

      this.launchMenuContainer = this.launchWrapper.append('div').attr('class', 'launchMenuContainer');
      this.launchMenuItems = this.launchMenuContainer.selectAll('.launch-item')
        .data(this.newmenu)
        .enter()
        .append('div')
        .attr('class', (m) => `launch-item launch-item--${m.key}`)
        .text((m) => m.name)
    }

    /**
     * initializes a reusable tooltip
     */
    initTooltip() {
        let tooltipD = [{x: -50, y: -50}];
        this.tooltip = this.container.selectAll('.tooltip')
            .data(tooltipD)
            .enter()
            .append('foreignObject')
            .attr('class', 'tooltip')
            .attr('contenteditable', 'true')
            .attr('height', '200')
            .attr('width', '200')
            .attr('x', (d) => d.x)
            .attr('y', (d) => d.y);
    }

    /**
     * initializes the input box for links
     */
    initInputBox() {
        this.inputBoxContainer = this.container
            .append('foreignObject')
            .attr('class', 'link-box')
            .attr('width', '200')
            .attr('height', '100');

        let question = document.createElement('span');
        question.innerText = '';
        question.classList.add('box__question');

        this.inputBoxQuestion = this.inputBoxContainer.append(() => question);

        let input = document.createElement('input');
        input.setAttribute('type', 'text');
        input.classList.add('box__input');
        input.setAttribute('placeholder', 'keyword');

        this.inputBox = this.inputBoxContainer.append(() => input);
    }

    /**
     * initializes the thing showing feedback for dragging in external files
     */
    initInfoBar() {
        this.infoBar = d3.select('#mynetwork')
            .append('div')
            .attr('id', 'info-bar');

        this.infoBar = this.infoBar
            .append('span');
    }

    /**
     * initializes this graph view
     */
    initGraph() {
        LinkView.init(this.links);
        NodeView.init(this.nodes);

        this.simulation = d3.forceSimulation();

        this.onTick = () => {
            LinkView.onTick();
            NodeView.onTick();
        };

        this.setupSimulation();
    }

    /**
     * initializes the lightbox to display focused nodes
     */
    initLightbox() {
        //adding div to html
        this.lightbox = this.div.append('div');
        this.lightbox.classed('lightbox', true);
        this.lightboxImage = this.lightbox.append('img');
        this.lightboxImage.attr('src', 'http://insomnia.rest/images/screens/main.png')
    }

    /**
     * adds the given node (from the graph model) to the graph view
     * @param {Node} node the model node to add to the view, as a corresponding view node
     * @param {number} [x] (optional) position of the new node
     * @param {number} [y] (optional) position of the new node
     */
    addNode(node, x = this.width / 2, y = this.height / 2) {
        let newNodeView;
        if (node.type === 'image') {
            newNodeView = new ImageNodeView(node, x, y);
        } else if (node.type === 'wiki') {
            newNodeView = new WikiNodeView(node, x, y);
        } else if (node.type === 'connector') {
            newNodeView = new ConnectorNodeView(node, x, y);
        } else {
            console.error('no view node added');
            return null;
        }
        this.nodes.push(newNodeView);
        this.restart();
        return newNodeView;
    }

    /**
     * adds the given model link to the view,
     * making a link view and restarting the simulation
     *
     * @param {Link} link (from the model)
     * @return {LinkView} the added link
     */
    addLink(link) {
        let newLinkView = new LinkView(link, this.getNode(link.source), this.getNode(link.target));
        this.links.push(newLinkView);
        this.restart();
        return newLinkView;
    }

    /**
     * removes the node with the given id from this view
     * @param {number} id
     */
    removeNode(id) {
        removeItem(this.nodes, id);
        _.map(this.getLinksToNode(id), (link) => this.removeLink(link.id));
        d3.select('.gnode-' + id).remove();
        this.restart();
    }

    /**
     * removes the link with the given id from the view
     * @param {number} id
     */
    removeLink(id) {
        removeItem(this.links, id);
        // d3.select(`.glink--${id}`).remove() //remove existing link on view
        this.restart();
    }

    /**
     * checks if a link exists between the given two nodes
     * @param {number} source
     * @param {number} target
     * @return {Boolean}
     */
    linkExists(source, target) {
        return this.links.some((link) => {
            if ((link.source.id == source && link.target.id == target) ||
                (link.source.id == target && link.target.id == source)) {
                return true;
            }
            return false;
        });
    }

    /**
     * returns all the links connecting the two given nodes
     * @param {number} source the id of the first node
     * @param {number} target the id of the second node
     * @return {Array<LinkView>}
     */
    getLinks(source, target) {
        let foundLinks = [];
        this.links.forEach((link) => {
            if ((link.source.id == source && link.target.id == target) ||
                (link.source.id == target && link.target.id == source)) {
                foundLinks.push(link);
            }
        });
        return foundLinks;
    }

    /**
     * returns all the links connecting the the given node
     * @param {number} source the id of the first node
     * @return {Array<LinkView>}
     */
    getLinksToNode(source) {
        let foundLinks = [];
        this.links.forEach((link) => {
            if (link.source.id == source || link.target.id == source) {
                foundLinks.push(link);
            }
        });
        return foundLinks;
    }

    /**
     * shows all the links to the given node
     * @param {String} id
     */
    showAllLinksToNode(id) {
        this.getLinksToNode(id).forEach((link) => link.show());
    }

    /**
     * hides all the links in the view
     */
    hideAllLinks() {
        this.links.forEach((link) => link.hide())
    }

    /**
     * shows all the links in the view
     */
    showAllLinks() {
        this.links.forEach((link) => link.show())
    }

    /**
     * deletes all the links in the view
     */
    deleteAllLinks() {
        let linkIds = _.map(this.links, (link) => link.id);
        linkIds.forEach((linkId) => this.removeLink(linkId));
    }

    /**
     * gets a node view given its ID
     * @param {String} id
     * @return {NodeView}
     */
    getNode(id) {
        return getItemById(this.nodes, id);
    }

    /**
     * gets a link view given its ID
     * @param {String} id
     * @return {LinkView}
     */
    getLink(id) {
        return getItemById(this.links, id);
    }

    /**
     * sets up the nodes and the links,
     * and the physics if it's enabled
     */
    setupSimulation() {
        this.simulation
            .nodes(this.nodes)
            .on('tick', this.onTick);
        if (this.enablePhysics) {
            this.defineManyBodyForce(0);
            this.defineLinkForce();
            centerForce = d3.forceCenter(this.width / 2, this.height / 2);
            this.simulation
                .force('link', this.force)
                .force('charge', this.manyBody)
                .force('center', centerForce);
        } else {
            this.simulation
            .force('link', null)
            .force('charge', null)
            .force('center', null);
        }
    }

    /**
     * defines the physical forces between the elements in the view
     *
     * @param {number} strength how far elements are repelled against each other
     */
    defineManyBodyForce(strength) {
        this.manyBody = d3.forceManyBody();
        this.manyBody.strength(strength);
    }

    /**
     * define new link forces for the simulation to use
     */
    defineLinkForce() {
        this.linkDistance = (link) => link.distance;
        this.linkStrength = (link) => link.strength;
        this.force = d3.forceLink(this.links)
                        .distance(this.linkDistance)
                        .strength(this.linkStrength);
    }

    /**
     * change the link force (only in the view)
     * @param {number} i the id of the link to change
     * @param {number} distance the new distance
     * @param {number} strength the new strength
     */
    changeLinkForce(i, distance, strength) {
        let link = this.getLink(i);
        link.distance = distance;
        link.strength = strength;
        this.redefineLinkForce();
    }

    /**
     * re-sets the view link forces to the model link forces
     */
    resetLinkForce() {
        this.links.forEach((link) => {
            link.resetForce();
        });
    }

    /**
     * update the simulation with new link forces
     */
    redefineLinkForce() {
        if (this.enablePhysics) {
            this.simulation
                .force('link')
                .distance(this.linkDistance)
                .strength(this.linkStrength);
        }
        this.simulation.alpha(1).restart();
    }

    /**
     * anchor the given node in one spot (still manually moveable)
     * @param {number} id the id of the node to fix
     */
    fixNode(id) {
        this.nodes.some((node) => {
            if (node.id === id) {
                node.fix();
                return true;
            }
            return false;
        })
    }

    /**
     * un-anchor the given node
     * @param {number} id the id of the node to unfix
     */
    unFixNode(id) {
        this.nodes.some((node) => {
            if (node.id === id) {
                node.unfix();
                return true;
            }
            return false;
        })
    }

    /**
     * restart the simulation counter and update it with new nodes, values, etc
     * called when nodes/links are added
     */
    restart() {
        // update the links
        LinkView.restart(this.links);

        // update the nodes
        NodeView.restart(this.nodes);

        // Update and restart the simulation.
        this.setupSimulation();
        this.simulation.alpha(1).restart();
    }

    /**
     * this.enablePhysics gets whether the physics are enabled
     */
    get enablePhysics() {
        return this._enablePhysics;
    }

    /**
     * this.enablePhysics = true or false turns on/off the physics
     */
    set enablePhysics(bool) {
        this._enablePhysics = bool;
        this.restart();
    }

    /**
     * toggles the physics of the view
     */
    togglePhysics() {
        this.enablePhysics = !this.enablePhysics;
    }

    /**
     * gets the x, y position of the viewport
     */
    getTranslate() {
        return this.getTransform().translate;
    }

    /**
     * gets the rate of zoom as a ratio
     */
    getZoomRate() {
        return this.getTransform().scale[0];
    }

    /**
     * get the value of the view transform
     * i.e. the position and size of the viewport relative to its original position and size
     * after having been panned and zoomed
     */
    getTransform() {
        return parseTransform(this.container.attr('transform'));
    }

    /**
     * get the center of the viewport while accounting for zooms and pans
     */
    getCenter() {
        let zoom = this.getZoomRate();
        if (zoom === 0) zoom = 1;
        let offsetX = 60, offsetY = 20;
        let randomX = Math.floor(Math.random() * 80 - 160), randomY = Math.floor(Math.random() * 80 - 160);
        return {
            x:  (randomX - offsetX - this.getTranslate()[0] + this.width / 2) / zoom,
            y:  (randomY - offsetY - this.getTranslate()[1] + this.height / 2) / zoom
        }

    }

    /**
     * put the nodes in random locations and hide all links
     */
    reorganize() {
        this.hideAllLinks();
        // this.deleteAllLinks();
        this.nodes.forEach(node => {
            [node.oldX, node.oldY] = [node.x, node.y]
            let [left, top] = this.getTranslate();
            let randomX = _.toInteger(-parseInt(left) + Math.random() * this.width),
                randomY = _.toInteger(-parseInt(top) + Math.random() * this.height);
            node.getSelection()
                .transition()
                .attr('x', randomX)
                .attr('y', randomY)
                .on('end', () => {
                    node.x = randomX;
                    node.y = randomY;
                });
        })
    }

    /**
     * reset the position of the nodes to before the reorganization
     */
    unreorganize() {
        this.showAllLinks();
        this.nodes.forEach(node => {
            node.getSelection()
                .transition()
                .attr('x', node.x = node.oldX)
                .attr('y', node.y = node.oldY)
        })
    }

    /**
     * gets this graph view in an exportable JSON format
     */
    toJSON() {
        return {
            nodes: this.nodes.map((node, idx, array) => {
                let obj = {
                    id: node.id,
                    type: node.type,
                    x: node.x,
                    y: node.y,
                    dob: node.dob,
                    _fixed: node._fixed,
                    _shrunk: node._shrunk,
                    _faded: node._faded,
                    width: node.width,
                    height: node.height,
                };

                if (node.type === 'image') {
                    obj.image = node.image;
                } else if (node.type === 'wiki' || node.type === 'connector') {
                    obj.text = node.text || "";
                }

                return obj;
            }),
            links: this.links.map((link, idx, array) => {
                let obj = {
                    id: link.id,
                    source: link.source.id,
                    target: link.target.id,
                    type: link.type,
                    strength: link.strength,
                    distance: link.distance,
                }

                return obj;
            })
        };
    }

    loadFromDB(){
        let data = importDoc().then(elements => {
            console.log('loading', elements);
            if (elements){
                this.import(elements)
            }
        })
    }

    /**
     * imports a graph json into this model
     * [not implemented yet]
     *
     * @param {JSON} data
     */
    import(data) {
        data.view.nodes.forEach((node) => {
            let modelNode = data.nodes.find(el => el.id === node.id);
            if (modelNode){
                this.addNode(modelNode, node.x, node.y)
            }
        });
        data.view.links.forEach((link) => {
            let modelLink = data.links.find(el => el.id === link.id);
            this.addLink(modelLink);
        });
    }

    /**
     * backs up this model to firebase
     */
    backup() {
        let exp = this.toJSON();
        saveDoc({view: exp});
    }

}
